import SearchSelect from "ui-components/SearchSelect";
import { useState, useEffect } from "react";
import { LostWorkflowProps } from "./types";
import { useIntl } from "react-intl";
import {
  LostWorksiteSchema,
  LostWorksiteReasonSchema,
  BrandSchema,
} from "../types";
import GetData from "./data";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

export const LostWorkflow = ({
  internalUser,
  setLostWorksiteData,
}: LostWorkflowProps) => {
  const intl = useIntl();
  const { brandChannelOptions, brandReasonOptions } = GetData(
    intl.formatMessage
  );
    const countryApiRequest = useCountryAxiosInstance();

  const [brandNameOptions, setBrandNameOptions] = useState<{ value: number; label: string }[]>([]);

  const [lostReason, setLostReason] = useState<{
    value: LostWorksiteReasonSchema;
    label: string;
  }>({
    value: "KKSolutionsOrProductsNotFound",
    label: intl.formatMessage({
      id: "terminate_reason_lost_reason_not_found",
      defaultMessage: "Prodotto o soluzione Kerakoll non trovato",
    }),
  });

  const [brandName, setBrandName] = useState<{ value: number; label: string }>();
  const [brandReason, setBrandReason] = useState<{
    value: string;
    label: string;
  }>(brandReasonOptions[0]);

  useEffect(() => {
    let data = {
      type: "lost",
      reason: {
        type: lostReason?.value,
        brand: {
          name: brandName?.value,
          reason: brandReason?.value || "not_specified",
        } as BrandSchema,
      },
    };

    if (lostReason?.value !== "OtherBrand" || !brandName?.value) {
      delete data.reason.brand;
    }
    setLostWorksiteData(data as LostWorksiteSchema);
  }, [lostReason, brandName, brandReason]);

  useEffect(() => {
    async function fetchBrands() {
      // brandNameOptions
      let result = await countryApiRequest.get("/competitors/all");
      result.push(result.splice(result.find(el=>el.name==='other_brand'), 1)[0]);
      const brandOptions = result.map((el) => ({
        value: el.id,
        label: intl.formatMessage({id:el.name}),
      }));

      setBrandNameOptions(brandOptions);
      setBrandName(brandOptions[0]);
    }
    fetchBrands();
  }, []);

  return (
    <>
      <SearchSelect
        label={intl.formatMessage({
          id: "terminate_reason_channel_label",
          defaultMessage: "Canale utilizzato",
        })}
        options={brandChannelOptions}
        value={lostReason}
        onChange={(e) => setLostReason(e)}
      />
      {lostReason.value === "OtherBrand" && (
        <div>
          <SearchSelect
            label={intl.formatMessage({
              id: "terminate_reason_lost_brand_label",
              defaultMessage: "Brand utilizzato",
            })}
            options={brandNameOptions}
            value={brandName}
            onChange={(e) => setBrandName(e)}
          />
          {brandName && (
            <SearchSelect
              label={intl.formatMessage({
                id: "terminate_reason_lost_other_brand_reason",
                defaultMessage: "Perché?",
              })}
              options={brandReasonOptions}
              isClearable={!internalUser}
              value={brandReason}
              onChange={(e) => setBrandReason(e)}
            />
          )}
        </div>
      )}
    </>
  );
};
